export const FILTER_COLLECTION_NAME = 'lifecycleAnalyticsFilters';
export const DISPLAY_DATE_FORMAT = 'MM-DD-YYYY';
export const MAX_SUPPLIERS_IN_TABLE = 35;

export const MONTH_ABBR = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec',
];

export const MONTH_FULL = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const PERFORMER_GROUP_ORDER = ['Top Performers', 'Typical Performers', 'Bottom Performers'];

export const PERFORMER_COLOR = 'rgba(255, 182, 72, 1)';
export const INTERNAL_TEAM_COLOR = '#531DAB';
